<imp-button
  class="HelpCenterButton"
  variant="ghost"
  [title]="'HELP_CENTER_DROPDOWN_LABEL' | translate"
  [icon]="['fas', 'question-circle']"
  [impContextMenu]="contextMenu"
  (action)="openDropdown()" />
<ng-template #contextMenu>
  <imp-context-menu-item
    [label]="'HELP_CENTER_DROPDOWN_LABEL' | translate"
    [icon]="['fal', 'memo-pad']"
    (action)="goToHelpCenter()" />
</ng-template>
